import { createSelector } from "reselect"
import { get, chain, keys, some, mapValues, orderBy, isNaN } from "lodash"
import { LOADING, ERROR, OK, UNKNOWN } from "helpers/data-statuses"

export const getSelectedConstraints = state => get(state, "modules.optimizationTrades.constraints")
const getCurrentConstraints = (state, props) => get(props, "currentConstraints.securities")
const getScorecardStatus = state => get(state, "global.data.scorecardData.status")
const getScannerStatus = state => get(state, "modules.optimizationScanner.status")
export const getTradeType = state => get(state, "modules.optimizationTrades.tradeType")
export const getTrades = (state, props) => get(props, "trades")
export const getAllPositions = (state, props) => get(props, "allPositions")

export const getConstraintsAndErrors = createSelector(
  [getSelectedConstraints],
  selectedConstraints => mapValues(selectedConstraints, constraint => {
    let maxError = null
    let minError = null
    if (constraint.constraintType === "range") {
      if (isNaN(parseFloat(constraint.min))) {
        minError = "Add non-blank, valid value"
      }

      if (isNaN(parseFloat(constraint.max))) {
        maxError = "Add non-blank, valid value"
      }

      if (!minError && !maxError && parseFloat(constraint.max) < parseFloat(constraint.min)) {
        maxError = "Max should be >= min"
      }
    }

    if (minError || maxError) {
      return { minError, maxError, ...constraint }
    } else {
      return constraint
    }
  }),
)

export const filterTrades = createSelector(
  [getTrades, getTradeType, getAllPositions],
  (trades, tradeTypeDisplay, allPositions) => {
    if (tradeTypeDisplay === "all") {
      return orderBy(allPositions, ["percentEquity", "key"], ["desc", "asc"])
    }
    // Filter out trades with a delta below 0.00005 because they will appear as 0.00% in the trades type tabs
    return chain(trades)
      .filter(item => item.tradeType === tradeTypeDisplay && Math.abs(item.percentEquity) >= 0.00005)
      .sortBy(item => -Math.abs(item.percentEquity))
      .value()
  },
)

export const getApplyButtonEnabled = createSelector(
  [getConstraintsAndErrors, getCurrentConstraints],
  (selectedConstraints, currentConstraints) => {
    const hasErrors = some(selectedConstraints, constraint => constraint.minError || constraint.maxError)

    if (hasErrors) {
      return false
    }

    // [TODO check for errors]
    if (keys(selectedConstraints).length !== keys(currentConstraints).length) {
      return true
    }

    return some(selectedConstraints, (constraint, key) => {
      if (!currentConstraints[key]) {
        return true
      }

      if (constraint.min !== currentConstraints[key].min
        || constraint.max !== currentConstraints[key].max
        || constraint.constraintType !== currentConstraints[key].constraintType) {
        return true
      }
    })
  },
)

export const getStatus = createSelector(
  [getScorecardStatus, getScannerStatus],
  (scorecardStatus, scannerStatus) => {
    if (scorecardStatus === ERROR || scannerStatus === ERROR) {
      return ERROR
    // if none is in error but any is loading or unknown, return loading
    } else if (scorecardStatus === UNKNOWN || scannerStatus === UNKNOWN
      || scorecardStatus === LOADING || scannerStatus === LOADING) {
      return LOADING
    } else {
      return OK
    }
  },
)
